'use client';
import { Layout } from 'antd';
import { useAtom } from 'jotai';
import { useEffect, useState, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { ieltsThemeAtom } from '@/store/home';
import { IeltsTheme } from '@/types';
import HeaderDesktopIeltsV2 from '@/components/home/IeltsHeader/HeaderDesktopV2';
import HeaderMobileIeltsV2 from '@/components/home/IeltsHeader/HeaderMobileV2';
import { isMobile } from '@flyer/utils';
import styles from '@/components/ielts/common/ListeningReading/Report/styles.module.scss';

interface IeltsClassicLayoutProps {
  children: ReactNode;
  contentClassName?: string;
}

export default function IeltsClassicLayout({
  children,
  contentClassName = '',
}: IeltsClassicLayoutProps) {
  const [ieltsTheme] = useAtom(ieltsThemeAtom);
  const [isMountedClient, setIsMountedClient] = useState<boolean>(false);

  useEffect(() => {
    setIsMountedClient(true);
  }, []);

  // Determine background class - only apply after client mount to prevent flash
  const bgClass = isMountedClient
    ? ieltsTheme !== IeltsTheme.CLASSIC_BLACK
      ? 'bg-white'
      : 'bg-[#16171A]'
    : ''; // No bg class during SSR, let body background show through

  return (
    <Layout
      suppressHydrationWarning
      className={twMerge('w-screen h-screen flex flex-col', bgClass)}
      style={{
        fontFamily: 'Inter, Open Sans',
      }}
    >
      <div className="flex flex-1 w-full overflow-hidden">
        {/* Sidebar/Header */}
        {isMountedClient ? (
          <>
            {!isMobile() && <HeaderDesktopIeltsV2 />}
            {isMobile() && <HeaderMobileIeltsV2 />}
          </>
        ) : (
          <div className="hidden md:block md:w-[260px] ielts-sidebar-placeholder"></div>
        )}

        {/* Main content */}
        <Layout.Content
          suppressHydrationWarning
          className={twMerge(
            'flex-1 pt-[60px] md:pt-[0px] overflow-y-auto overflow-x-hidden h-full',
            styles[`${ieltsTheme.toLowerCase()}_scrollbar`],
            contentClassName,
          )}
        >
          {children}
        </Layout.Content>
      </div>
    </Layout>
  );
}
